import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export type StagingPreviewNavigateCommandProperties = CommandProperties & {
	url: string;
};

/**
 * Asks the Confluence host to show different content in the staging preview without reloading the
 * iframe. Resolves `true` when the host navigated in place (the sender keeps `src` pinned) and
 * `false` when it declined (the sender reloads).
 */
export const StagingPreviewNavigateCommand: CommandConstructor<
	StagingPreviewNavigateCommandProperties,
	boolean
> = createCommand<StagingPreviewNavigateCommandProperties, boolean>(
	'staging-preview-navigate-command',
);
